import React from 'react';
import { useHistory as useRouterHistory } from 'react-router-dom';
import Button from './Button';

interface BackButtonProps {
	/**
	 * Rota específica para voltar (opcional)
	 * Se não fornecida, usa history.goBack()
	 */
	to?: string;
	
	/**
	 * Texto do botão (padrão: "Voltar")
	 */
	title?: string;
	
	/**
	 * Se deve verificar se há mudanças não salvas antes de voltar
	 */
	checkUnsavedChanges?: boolean;
	
	/**
	 * Função para verificar se há mudanças não salvas
	 */
	isDirty?: boolean;
	
	/**
	 * Função para exibir modal de confirmação
	 */
	onShowConfirmation?: () => void;
	
	/**
	 * Classe CSS adicional
	 */
	className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({
	to,
	title = "Voltar",
	checkUnsavedChanges = false,
	isDirty = false,
	onShowConfirmation,
	className = ""
}) => {
	const history = useRouterHistory();

	const handleClick = () => {
		if (checkUnsavedChanges && isDirty && onShowConfirmation) {
			onShowConfirmation();
		} else if (to) {
			history.push(to);
		} else {
			history.goBack();
		}
	};

	return (
		<Button
			title={title}
			contained={false}
			type="button"
			onClick={handleClick}
			className={className}
		/>
	);
};

export default BackButton;

